module.exports = __webpack_public_path__ + "media/step_4_ru.57e7c98a.mp3";